'use client'

import { Bell } from 'lucide-react'
import { toast } from 'sonner'
import { cn } from '@/lib/utils'
import type { NotificationItem } from '@/services/notifications/types'
import { Notification } from './index'
import { getKindStyle } from './kind-style'

interface NotificationToastProps {
  toastId: string | number
  notification: NotificationItem
  onClick: () => void
}

export function NotificationToast({ toastId, notification, onClick }: NotificationToastProps) {
  const style = getKindStyle(notification.kind)
  return (
    <button
      type="button"
      onClick={() => {
        onClick()
        toast.dismiss(toastId)
      }}
      className={cn(
        // Largura EXPLÍCITA, não `w-full`. Em `toast.custom` o sonner marca o
        // <li> com data-styled="false", e a regra que dá `width: var(--width)`
        // só vale pra data-styled="true" — o <li> fica absoluto e sem largura.
        // Percentual não conta no cálculo intrínseco do pai, então sobraria o
        // min-content do texto, que o `overflow-wrap: anywhere` do próprio
        // sonner reduz a UM CARACTERE. Resultado: título em coluna de letras.
        'flex w-[var(--width,356px)] max-w-full cursor-pointer items-start gap-3 rounded-lg border px-3 py-2.5 text-left shadow-md transition-shadow hover:shadow-lg',
        style.borderClass,
        // Fundo OPACO: o toast fica sobre o conteúdo da página.
        style.toastBgClass,
      )}
    >
      <Notification notification={notification}>
        <Notification.KindIcon className="mt-0.5" />
        <div className="min-w-0 flex-1">
          <Notification.Title />
          <Notification.Body preview className="mt-1" />
        </div>
      </Notification>
    </button>
  )
}

interface MultiNotificationToastProps {
  toastId: string | number
  count: number
  onClick: () => void
}

/** Rajada: um toast só em vez de N empilhados. */
export function MultiNotificationToast({ toastId, count, onClick }: MultiNotificationToastProps) {
  return (
    <button
      type="button"
      onClick={() => {
        onClick()
        toast.dismiss(toastId)
      }}
      // Mesma largura explícita do NotificationToast — ver o comentário lá.
      className="flex w-[var(--width,356px)] max-w-full cursor-pointer items-center gap-3 rounded-lg border border-border bg-card px-3 py-2.5 text-left shadow-md transition-shadow hover:shadow-lg"
    >
      <Bell className="size-4 shrink-0 text-foreground" />
      <span className="text-sm font-medium">Você tem {count} novas notificações</span>
    </button>
  )
}
